<template>
  <f7-page no-toolbar no-swipeback name="financial" class="page-center">
    <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.navigate('/home/')">
          <i class="f7-icons" style="color: white">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("home_0161") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="content" v-if="bonus.Enable">
      <div class="caption">
        <div class="c1">{{ $t("bonusv0_04") }}</div>
        <div class="c2">{{ bonus.BeginTS | time }} ~ {{ bonus.EndTS | time }}</div>
        <div class="c3">{{ $t("bonusv0_05") }}</div>
        <div class="c4">{{ $t("bonusv2_01") }}</div>
      </div>
      <div v-for="(item, index) in referralPointsSeasonDetailList" :key="index">
        <div class="onemore" >
          <div class="top">
            <div class="left">{{ item.VIPLevelName.toUpperCase() }}</div>
            <div class="right">
              <img src="../static/images/yt999/zhu.png" alt="" srcset="" style="height: 25px; margin-right: 10px" />
              <span >{{ currencySymbol }}&nbsp;{{ item.BonusAmountForSingleRedemption | formatCurrency }}</span>
            </div>
          </div>
          <div class="mtext">
            <p>{{ $t("bonusv2_04") }}：<span>{{Math.floor(item.TotalReferralPoints - item.TotalReferralPointsUsed)}}</span></p>
            <p>{{ $t("bonusv2_02") }}：<span style="color: red;">{{ item.BasicPointsPerNewSubordinatesVIP }}</span></p>
            <p style="position: relative;">{{ $t("bonusv2_03") }}：<span style="color: red;">{{ item.ExchangePointsForSingleRedemption }}</span></p>
          </div>
          <div class="go"  @click="referrerPointsExchange(item)">
            {{ $t("bonusv2_05") }}
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="vanflag" class="van">
      <div class="">
        <div style="height: 115px"><img src="../static/images/yt999/bonusred.png" alt="" srcset="" width="100%" /></div>

        <div class="f1">
          {{ $t("home_0156") }}
        </div>
        <div>
          <div>{{ $t("bonusv2_06") }}</div>
          <div class="f3">
            <span style="font-size: 12px">{{ currencySymbol }}</span>&nbsp;{{ bonusAmountForSingleRedemption | formatCurrency }}
          </div>
          <div>{{ $t("bonusv0_02") }}</div>
        </div>
        <div class="go" @click="closevanFlag()">{{ $t("common_0001") }}</div>
      </div>
    </van-popup>


  </f7-page>
</template>

<script>
import { getCookie, getStore } from "@/config/utils";
import {  getbonusForReferralPointsSeasonStatu,getReferralPointsSeasonDetail, referrerPointsExchange } from "../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      vanflag: false,
      currencySymbol: getStore("currencySymbol"),
      bonus: {},
      referralPointsSeasonDetailList: [],
      backData: {},
      selectId: 0,
      bonusAmountForSingleRedemption: 0,
      btnFlag: true,
      cancel: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    closevanFlag() {
      this.vanflag = false;

    },
    checkBonus() {
      const self = this;
      getbonusForReferralPointsSeasonStatu().then((data) => {
        if (data.Code === "NoError") {
          self.bonus = data.Data;
        }
      });
    },
    async referrerPointsExchange(item){
      const self = this;
      if (!self.btnFlag) {
        return;
      }

      const params = {
        TargetVIPLevelID: item.VIPLevelID,
        ConsumeHigherLevelPoints: false
      };

      if ((item.TotalReferralPoints - item.TotalReferralPointsUsed)<item.ExchangePointsForSingleRedemption) {
        this.cancel = await new Promise((resolve) => {
          self.$f7.$(".dialog-backdrop").css("background", "rgba(0, 4, 7, 0.77)");
          this.$f7.dialog.create({
            title: this.$t("common_0004"),
            text: this.$t("bonusv2_07"),
            cssClass: "dialog-logout",
            buttons: [
              {
                text: this.$t("common_0002"), // 取消按钮
                cssClass: "dialog-cancel",
                onClick: () => resolve(true), // 传递 true 表示取消
              },
              {
                text: this.$t("common_0001"), // 确认按钮
                cssClass: "dialog-ok",
                onClick: () => resolve(false), // 传递 false 表示继续
              },
            ],
          }).open();
        });

      }
      if (self.cancel) {
        return;
      }else{
        if ((item.TotalReferralPoints - item.TotalReferralPointsUsed)<item.ExchangePointsForSingleRedemption) {
          params.ConsumeHigherLevelPoints = true;
        }
      }
      self.btnFlag = false;
      self.bonusAmountForSingleRedemption = item.BonusAmountForSingleRedemption;
      let d = { data: JSON.stringify(params) };
      referrerPointsExchange(d).then((data) => {
        if (data.Code === "NoError") {
          self.vanflag = true;
          self.getReferralPointsSeasonDetail();
        } else {
          self.$f7.dialog.alert(data.Data, this.$t("common_0004"));
        }
        self.btnFlag = true;
      });
    },
    getReferralPointsSeasonDetail(){
      getReferralPointsSeasonDetail().then((data) => {
        if (data.Code === "NoError") {
          this.referralPointsSeasonDetailList = data.Data;
        }
      });
    }
  },
  created() {
    this.checkBonus();
    this.getReferralPointsSeasonDetail();
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
::v-deep .navbar-inner {
  //头部颜色更换
  color: white;
  background: linear-gradient(to right, var(--f7-THEME-colorbg), #0887b2);
}
::v-deep .page-content::after {
  height: 0;
}
.content {
  padding: 10px;
  min-height: 98%;
  background: var(--f7-THEME-color2);
  background-image: url(../static/images/yt999/member_center_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 7%;
  .caption {
    background: white;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    .c1 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 7px;
    }
    .c2 {
      color: #848484;
      font-weight: bold;
      font-size: 12px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e5e5e5;
    }
    .c3 {
      padding: 15px 0;
      font-weight: bold;
    }
    .c4 {
      text-align: left;
    }
  }
  .onemore {
    background: white;
    border-radius: 10px;
    padding: 20px;
    margin-top: 15px;
    .top {
      display: grid;
      grid-template-columns: 20% 80%;
      align-items: center;
      .left {
        font-size: 18px;
        font-weight: bold;
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-weight: bold;
        color: red;
      }
      border-bottom: 1px solid #e2e2e2;
      padding-bottom: 5px;
    }
    .mtext{
      p::before{
        content: '※';
        font-size: 16px;
        position: absolute;
        top: -1px;
        left: 0;

      }
      p{
        margin: 10px 0;
        padding-left: 15px;
        position: relative;
      }
    }
    .go {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: var(--f7-THEME-color);
      border-radius: 10px;
      color: white;
      font-weight: bold;
      text-align: center;
      margin: 15px auto 0px auto;
    }
    .nogo{
      background: #ccc;
    }
  }
}
.van {
  width: 65%;
  border-radius: 20px;
  text-align: center;
  padding: 15px;
  .f1 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .f3 {
    font-size: 20px;
    font-weight: bold;
    margin: 10px 0;
    color: red;
  }
  .go {
    width: 70%;
    height: 40px;
    line-height: 40px;
    background: var(--f7-THEME-color);
    margin: 20px auto 10px auto;
    border-radius: 10px;
    color: white;
    font-weight: bold;
  }
}
.vanbuy {
  border-radius: 20px 20px 0 0;
  // padding-bottom: 55px;
}
.buypopup {
  display: block !important;
  padding: 0px !important;

  #add {
    position: absolute;
    right: 25px;
    top: 5px;
    font-size: 23px;
  }
  .yuer {
    width: 100%;
    position: absolute;
    right: 60px;
  }
  .yiban {
    display: flex;

    div {
      width: 50%;
    }
    div:nth-child(1) {
      width: 40%;
    }

    div:nth-child(2) {
      width: 70%;
    }
  }

  .paddding {
    padding: 10px;
    margin: 10px;
    padding: 5px;
    border-bottom: 1px solid #e1e0e0;

    div:nth-child(2) {
      text-align: right;
    }
  }
  .price {
    span {
      width: 50px;
      height: 20px;
      display: block;
      text-align: center;
      line-height: 20px;
      border-radius: 10px;
      border: 1px solid var(--f7-THEME-color);
      margin: 0px 3px;
    }
  }
  .one {
    background: var(--f7-THEME-color);
    color: white;
    padding: 11px 0 7px 28px;
  }

  .four {
    border: none;
    padding: 10px 0 13px 20px;

    span {
      border: none;
    }
  }

  .paybtn {
    text-align: center !important;
    line-height: 36px;
    border-radius: 20px;
    background: var(--f7-THEME-color);
    height: 36px;
    color: #ffffff;
    font-size: 16px;
    width: 113px !important;
    margin-left: 25%;
    margin-top: 3px;
  }
}
</style>
